import React from 'react'
import * as bs4 from 'reactstrap'
import '../../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import Select from 'react-select';
import Navbar from '../../Navbar'
import { ScaleLoader } from 'react-spinners';
import { async } from 'q';
const { proxy } = require('../../../ip_api.config')

class Flim_EditMasterStandard extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            id: '',
            previewbom: '',
            isLoading: false,
            arr_item: [],
            arr_check: [],
            arr_show: [],
            arr_save: [],
        }
    }

    componentDidMount() {
        if (localStorage.getItem("ID_User") !== null) {
            this.setState({
                id: this.props.location.state.id_edit
            }, () => {
                this.get_masterStandard()
            })
        } else {
            this.props.history.push({
                pathname: '/'
            })
        }
    }

    get_masterStandard = () => {
        console.log('id', this.state.id)
        this.setState({ isLoading: true })
        let arr = []
        let temp
        let url = proxy.server + '/flim/getMaster_Standard'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: this.state.id
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    let data = {
                        id: val.id,
                        Type: val.Type,
                        DefaultOrderType: val.DefaultOrderType,
                        EcoResTrackingDimensionGroup_Name: val.EcoResTrackingDimensionGroup_Name,
                        ItemGroupId: val.ItemGroupId,
                        CostGroupId: val.CostGroupId,
                        BatchNumGroupId: val.BatchNumGroupId,
                        SerialNumGroupId: val.SerialNumGroupId,
                        InventTableModuleInvent_UnitId: val.InventTableModuleInvent_UnitId,
                        InventTableModulePurch_UnitId: val.InventTableModulePurch_UnitId,
                        InventTableModulePurch_OverDeliveryPct: val.InventTableModulePurch_OverDeliveryPct,
                        InventTableModulePurch_UnderDeliveryPct: val.InventTableModulePurch_UnderDeliveryPct,
                        InventTableModuleSales_UnitId: val.InventTableModuleSales_UnitId,
                        ECL_NumberSequenceGroupProd: val.ECL_NumberSequenceGroupProd,
                        BOMUnitId: val.BOMUnitId,
                        DefaultDimension: val.DefaultDimension
                    }

                    arr.push(data)
                })
                temp = this.state.arr_save.concat(arr)
                this.setState({ arr_save: temp }, () => {
                    console.log("arr_save", this.state.arr_save)
                    this.preview_masterStandard()
                })
            })
    }

    preview_masterStandard = () => {
        let arr = []

        this.state.arr_save.map(function (val, i) {
            arr.push(
                <tr>
                    <td>{i + 1}</td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 150 }}>
                            <bs4.Input type="text" name="Type" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.Type} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 150 }}>
                            <bs4.Input type="text" name="DefaultOrderType" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.DefaultOrderType} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 150 }}>
                            <bs4.Input type="text" name="EcoResTrackingDimensionGroup_Name" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.EcoResTrackingDimensionGroup_Name} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 150 }}>
                            <bs4.Input type="text" name="ItemGroupId" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.ItemGroupId} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 150 }}>
                            <bs4.Input type="text" name="CostGroupId" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.CostGroupId} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 150 }}>
                            <bs4.Input type="text" name="BatchNumGroupId" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.BatchNumGroupId} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 150 }}>
                            <bs4.Input type="text" name="SerialNumGroupId" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.SerialNumGroupId} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 150 }}>
                            <bs4.Input type="text" name="InventTableModuleInvent_UnitId" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.InventTableModuleInvent_UnitId} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 150 }}>
                            <bs4.Input type="text" name="InventTableModulePurch_UnitId" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.InventTableModulePurch_UnitId} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 150 }}>
                            <bs4.Input type="text" name="InventTableModulePurch_OverDeliveryPct" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.InventTableModulePurch_OverDeliveryPct} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 150 }}>
                            <bs4.Input type="text" name="InventTableModulePurch_UnderDeliveryPct" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.InventTableModulePurch_UnderDeliveryPct} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 150 }}>
                            <bs4.Input type="text" name="InventTableModuleSales_UnitId" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.InventTableModuleSales_UnitId} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 150 }}>
                            <bs4.Input type="text" name="ECL_NumberSequenceGroupProd" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.ECL_NumberSequenceGroupProd} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 150 }}>
                            <bs4.Input type="text" name="BOMUnitId" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.BOMUnitId} />
                        </bs4.Col>
                    </td>
                    <td>
                        <bs4.Col sm='12' style={{ width: 150 }}>
                            <bs4.Input type="text" name="DefaultDimension" onChange={(e) => this.handleChangeItem(i, e.target.name, e.target.value)} value={val.DefaultDimension} />
                        </bs4.Col>
                    </td>
                </tr>
            )
        }, this)
        this.setState({ previewbom: arr, isLoading: false })
    }

    handleChangeItem = (index, name, value) => {
        if (index === 'a') {
            if (name === 'Type') {
                this.state.arr_save.map(function (val, i) {
                    val.Type = value
                })
            } else if (name === 'DefaultOrderType') {
                this.state.arr_save.map(function (val, i) {
                    val.DefaultOrderType = value
                })
            } else if (name === 'EcoResTrackingDimensionGroup_Name') {
                this.state.arr_save.map(function (val, i) {
                    val.EcoResTrackingDimensionGroup_Name = value
                })
            } else if (name === 'ItemGroupId') {
                this.state.arr_save.map(function (val, i) {
                    val.ItemGroupId = value
                })
            } else if (name === 'CostGroupId') {
                this.state.arr_save.map(function (val, i) {
                    val.CostGroupId = value
                })
            } else if (name === 'BatchNumGroupId') {
                this.state.arr_save.map(function (val, i) {
                    val.BatchNumGroupId = value
                })
            } else if (name === 'SerialNumGroupId') {
                this.state.arr_save.map(function (val, i) {
                    val.SerialNumGroupId = value
                })
            } else if (name === 'InventTableModuleInvent_UnitId') {
                this.state.arr_save.map(function (val, i) {
                    val.InventTableModuleInvent_UnitId = value
                })
            } else if (name === 'InventTableModulePurch_UnitId') {
                this.state.arr_save.map(function (val, i) {
                    val.InventTableModulePurch_UnitId = value
                })
            } else if (name === 'InventTableModulePurch_OverDeliveryPct') {
                this.state.arr_save.map(function (val, i) {
                    val.InventTableModulePurch_OverDeliveryPct = value
                })
            } else if (name === 'InventTableModulePurch_UnderDeliveryPct') {
                this.state.arr_save.map(function (val, i) {
                    val.InventTableModulePurch_UnderDeliveryPct = value
                })
            } else if (name === 'InventTableModuleSales_UnitId') {
                this.state.arr_save.map(function (val, i) {
                    val.InventTableModuleSales_UnitId = value
                })
            } else if (name === 'ECL_NumberSequenceGroupProd') {
                this.state.arr_save.map(function (val, i) {
                    val.ECL_NumberSequenceGroupProd = value
                })
            } else if (name === 'BOMUnitId') {
                this.state.arr_save.map(function (val, i) {
                    val.BOMUnitId = value
                })
            } else if (name === 'DefaultDimension') {
                this.state.arr_save.map(function (val, i) {
                    val.DefaultDimension = value
                })
            }
        } else if (name === 'Type') {
            this.state.arr_save[index].Type = value
        } else if (name === 'DefaultOrderType') {
            this.state.arr_save[index].DefaultOrderType = value
        } else if (name === 'EcoResTrackingDimensionGroup_Name') {
            this.state.arr_save[index].EcoResTrackingDimensionGroup_Name = value
        } else if (name === 'ItemGroupId') {
            this.state.arr_save[index].ItemGroupId = value
        } else if (name === 'CostGroupId') {
            this.state.arr_save[index].CostGroupId = value
        } else if (name === 'BatchNumGroupId') {
            this.state.arr_save[index].BatchNumGroupId = value
        } else if (name === 'SerialNumGroupId') {
            this.state.arr_save[index].SerialNumGroupId = value
        } else if (name === 'InventTableModuleInvent_UnitId') {
            this.state.arr_save[index].InventTableModuleInvent_UnitId = value
        } else if (name === 'InventTableModulePurch_UnitId') {
            this.state.arr_save[index].InventTableModulePurch_UnitId = value
        } else if (name === 'InventTableModulePurch_OverDeliveryPct') {
            this.state.arr_save[index].InventTableModulePurch_OverDeliveryPct = value
        } else if (name === 'InventTableModulePurch_UnderDeliveryPct') {
            this.state.arr_save[index].InventTableModulePurch_UnderDeliveryPct = value
        } else if (name === 'InventTableModuleSales_UnitId') {
            this.state.arr_save[index].InventTableModuleSales_UnitId = value
        } else if (name === 'ECL_NumberSequenceGroupProd') {
            this.state.arr_save[index].ECL_NumberSequenceGroupProd = value
        } else if (name === 'BOMUnitId') {
            this.state.arr_save[index].BOMUnitId = value
        } else if (name === 'DefaultDimension') {
            this.state.arr_save[index].DefaultDimension = value
        }

        this.setState({
            arr_save: this.state.arr_save
        }, () => {
            this.preview_masterStandard()
        })
    }

    update_masterStandard = () => {
        if (window.confirm("กรุณายืนยันการบันทึก")) {
            this.setState({ isLoading: true })
            let url = proxy.server + '/flim/update_masterStandard'
            fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=utf-8"
                },
                body: JSON.stringify({
                    arr: this.state.arr_save
                })
            })
                .then(response => response.json())
                .then((responseJson) => {
                    console.log("responseJson", responseJson)
                    if (responseJson.status === 201) {
                        this.setState({ isLoading: false })
                        this.props.history.push({
                            pathname: '/Flim/MasterStandard'
                        })
                    } else {
                        this.setState({ isLoading: false })
                        alert('ไม่สามารถบันทึกข้อมูลได้ กรุณาตรวจสอบข้อมูล')
                    }
                })
        }
    }

    render() {
        return <div>
            <Navbar nav={'Flim'} menu={'Flim_MasterBomLine'} />
            <div style={{ marginLeft: 20, marginTop: 50, marginRight: 10 }}>
                <bs4.FormGroup row style={{ marginLeft: 10, marginBottom: 20 }}>
                    <bs4.Label style={{ fontSize: 20, fontWeight: 500, marginRight: 20 }} >Edit Master Standard</bs4.Label>
                    <bs4.Button color="warning" style={{ fontSize: 16, fontWeight: 500, width: 150, marginRight: 20 }} onClick={() => this.update_masterStandard()}>SAVE</bs4.Button>
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                </bs4.FormGroup>
                <bs4.Table bordered hover style={{ fontSize: 15 }}>
                    <thead style={{ backgroundColor: '#E8DCCD', color: '#000' }}>
                        <tr style={{ textAlign: 'center' }}>
                            <th>ลำดับ</th>
                            <th>Type</th>
                            <th>DefaultOrderType</th>
                            <th>EcoResTracking<br />Dimension<br />Group_Name</th>
                            <th>ItemGroupId</th>
                            <th>CostGroupId</th>
                            <th>BatchNumGroupId</th>
                            <th>SerialNumGroupId</th>
                            <th>InventTable<br />ModuleInvent<br />_UnitId</th>
                            <th>InventTable<br />ModulePurch<br />_UnitId</th>
                            <th>InventTable<br />ModulePurch_<br />OverDeliveryPct</th>
                            <th>InventTable<br />ModulePurch_<br />UnderDeliveryPct</th>
                            <th>InventTable<br />ModuleSales_<br />UnitId</th>
                            <th>ECL_Number<br />Sequence<br />GroupProd</th>
                            <th>BOMUnitId</th>
                            <th>Default<br />Dimension</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td></td>
                            <td>
                                <bs4.Col sm='12' style={{ width: 150 }}>
                                    <bs4.Input type="text" name="Type" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                </bs4.Col>
                            </td>
                            <td>
                                <bs4.Col sm='12' style={{ width: 150 }}>
                                    <bs4.Input type="text" name="DefaultOrderType" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                </bs4.Col>
                            </td>
                            <td>
                                <bs4.Col sm='12' style={{ width: 150 }}>
                                    <bs4.Input type="text" name="EcoResTrackingDimensionGroup_Name" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                </bs4.Col>
                            </td>
                            <td>
                                <bs4.Col sm='12' style={{ width: 150 }}>
                                    <bs4.Input type="text" name="ItemGroupId" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                </bs4.Col>
                            </td>
                            <td>
                                <bs4.Col sm='12' style={{ width: 150 }}>
                                    <bs4.Input type="text" name="CostGroupId" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                </bs4.Col>
                            </td>
                            <td>
                                <bs4.Col sm='12' style={{ width: 150 }}>
                                    <bs4.Input type="text" name="BatchNumGroupId" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                </bs4.Col>
                            </td>
                            <td>
                                <bs4.Col sm='12' style={{ width: 150 }}>
                                    <bs4.Input type="text" name="SerialNumGroupId" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                </bs4.Col>
                            </td>
                            <td>
                                <bs4.Col sm='12' style={{ width: 150 }}>
                                    <bs4.Input type="text" name="InventTableModuleInvent_UnitId" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                </bs4.Col>
                            </td>
                            <td>
                                <bs4.Col sm='12' style={{ width: 150 }}>
                                    <bs4.Input type="text" name="InventTableModulePurch_UnitId" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                </bs4.Col>
                            </td>
                            <td>
                                <bs4.Col sm='12' style={{ width: 150 }}>
                                    <bs4.Input type="text" name="InventTableModulePurch_OverDeliveryPct" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                </bs4.Col>
                            </td>
                            <td>
                                <bs4.Col sm='12' style={{ width: 150 }}>
                                    <bs4.Input type="text" name="InventTableModulePurch_UnderDeliveryPct" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                </bs4.Col>
                            </td>
                            <td>
                                <bs4.Col sm='12' style={{ width: 150 }}>
                                    <bs4.Input type="text" name="InventTableModuleSales_UnitId" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                </bs4.Col>
                            </td>
                            <td>
                                <bs4.Col sm='12' style={{ width: 150 }}>
                                    <bs4.Input type="text" name="ECL_NumberSequenceGroupProd" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                </bs4.Col>
                            </td>
                            <td>
                                <bs4.Col sm='12' style={{ width: 150 }}>
                                    <bs4.Input type="text" name="BOMUnitId" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                </bs4.Col>
                            </td>
                            <td>
                                <bs4.Col sm='12' style={{ width: 150 }}>
                                    <bs4.Input type="text" name="DefaultDimension" onChange={(e) => this.handleChangeItem('a', e.target.name, e.target.value)} />
                                </bs4.Col>
                            </td>
                        </tr>
                        {this.state.previewbom}
                    </tbody>
                </bs4.Table>
            </div>
        </div>
    }
}

export default Flim_EditMasterStandard